/*
 * Purpose: Route guard — mock banner + delegates production overlay to AuthGateOverlay
 * Last modified: 2026-06-28 | Agent
 * Completeness: 94
 */
import { Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

export function AuthRouteGuard() {
  const ready = useAuthStore((s) => s.ready);

  if (!ready) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center text-muted-foreground text-sm">
        Checking session…
      </div>
    );
  }

  return <Outlet />;
}

export default AuthRouteGuard;
